import { useQuery } from "react-query";
import { workflowsApi } from "@/react/api";

const fetchTotalCount = () => workflowsApi.list({ params: { per_page: 1 } });

export const useTotalWorkflowsCount = () =>
  useQuery("totalWorkflows", fetchTotalCount);
